<template>
  <div class="login-page">
    <CommonOverlay :show="isLoading" title="Signing In" message="Please wait while we sign you in..." style="z-index: 10000; position: fixed; top: 0; left: 0;" />
    <b-container>       
      <center>
      <Widget class="mx-auto loginpage-widget">
        <h5 class="logo" style="margin-bottom: 50px;">
        <i class="fa fa-circle text-warning" />
          <img  type="submit" src="../../assets/teamio-logo.png" alt="Log in to Teamio with Google" width="100" />
        <i class="fa fa-circle text-warning" />
      </h5>     
      <!--<b-button type="submit" size="sm" variant="inverse" @click="handleClickSignIn" id="google-login">Login in to Teamio with Google</b-button>-->
      <div class="card" role="button" tabindex="0" @click="handleClickSignIn" @keydown.enter="handleClickSignIn" @keydown.space.prevent="handleClickSignIn">
        <img src="../../assets/btn_google_signin_light_normal_web.png" alt="Log in to Teamio with Google" draggable="false" />
        <img src="../../assets/btn_google_signin_light_focus_web.png" class="hover-image" alt="" draggable="false" />
        <img src="../../assets/btn_google_signin_light_pressed_web.png" class="click-image" alt="" draggable="false" />
      </div>
      
      <div class="mt-3 text-center">
        <span class="text-muted">or</span>
      </div>
      
      <div class="card microsoft-login-card mt-3" role="button" tabindex="0" @click="handleClickMicrosoftSignIn" @keydown.enter="handleClickMicrosoftSignIn" @keydown.space.prevent="handleClickMicrosoftSignIn">
        <div class="microsoft-login-button">
          <svg class="microsoft-logo" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="12" y="1" width="9" height="9" fill="#00a4ef"/>
            <rect x="1" y="12" width="9" height="9" fill="#ffb900"/>
            <rect x="12" y="12" width="9" height="9" fill="#7fba00"/>
          </svg>
          <span class="microsoft-text">Sign in with Microsoft</span>
        </div>
      </div>

      <!-- Demo site (Try Teamio, plan Task 6.7): the public /try page. Guard: cypress/node-tests/login-try-demo-link.test.js -->
      <p class="try-demo-link mt-4 mb-0">
        New to Teamio? <router-link :to="{ name: 'TryTeamio' }" data-test="login-try-demo">Try the live demo</router-link>
      </p>
      <!--
      <div>
        <p v-b-toggle.collapse-1 class="mt-4 fw-semi-bold trouble-logging-in-header">Having trouble Logging-in?</p>
        <b-collapse id="collapse-1" class="mt-2">
          <b-card>
            <p class="card-text">Collapse contents Here</p>
            
          </b-card>
        </b-collapse>
      </div>
      -->  
      </Widget>
      </center>
    </b-container>
    <footer class="footer">
      2025 &copy; Teamio.app
    </footer>
  </div>
</template>

<script>
/* eslint-disable */

import Widget from '@/components/Widget/Widget';
import CommonOverlay from "@/components/CommonOverlay";
import { mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import Vue from 'vue';
import _ from 'lodash';
import microsoftAuthService from '@/services/microsoftAuth';
import { createLoginLogger } from '@/utils/loginLogger';

export default {
  name: 'LoginPage',
  components: { Widget, CommonOverlay },
  props: ['msg'],

  mounted() {
    if (window.localStorage.getItem('authenticated') === 'true') {
      let redirectPath = window.localStorage.getItem('redirectPath');
      this.$router.push(redirectPath);
    }
  },

  created() {
    // Check for message from route params (legacy) or query string (hard navigation)
    const msg = this.msg || (this.$route && this.$route.query && this.$route.query.msg);
    if(msg) {
      console.log('msg', msg);
      this.$toast.error(msg);
    }
  },

  data() {
    return {
      isInit: false,
      isSignIn: false,
      errorMessage: null,
      localLoading: false, // Local loading state for login process
      params: {
        client_id: "524295260528-5jm27h7t93sde0b6tltbsr19cismn7lh.apps.googleusercontent.com" // TODO: hardcoded. Remove this
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
          width: 250,
          height: 50,
          longtitle: true
      }
    };
  },
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('customer', ['login', 'googleLogin', 'microsoftLogin', 'fbGoogleLogin', 'watchMetaData', 'clearMetaData', 'getSitesAndEmployeesAndStatusesAndListsAndSettingsAndPatientsAndProviders']),
    ...mapMutations('customer', ['setRules']),
    ...mapMutations('alert', ['setLoading']),

    async handleClickSignIn() {
      const logger = createLoginLogger('google');
      logger.step('button-clicked');
      try {
        this.localLoading = true; // Set local loading state to true
        this.setLoading(true); // Also update the store loading state
        logger.step('fbGoogleLogin-begin');
        const idToken = await this.fbGoogleLogin(logger.id);
        logger.step('fbGoogleLogin-success', { hasIdToken: !!idToken });
        logger.step('backend-call-begin');
        const res = await this.googleLogin({ idToken, loginAttemptId: logger.id });
        logger.step('backend-call-result', {
          status: res && res.status,
          userCount: Array.isArray(res && res.data) ? res.data.length : (res && res.data ? 1 : 0),
        });

        if(res && res.status === 200) {
          if (Array.isArray(res.data) && res.data.length > 1) {
            logger.step('route-select-site', { siteCount: res.data.length });
            localStorage.setItem('userSites', JSON.stringify(res.data));
            this.$router.push({path: '/select-site'});
            return;
          } else {
            // Pass router as part of the context to the store action
            logger.step('handle-select-site');
            await this.$store.dispatch('customer/handleSelectSite', res.data);
          }
        }
        logger.step('login-complete');
      } catch(error) {
        logger.error('failed', error);
        var errorCode = error.code;
        var errorMessage = error.message;
        var email = error.email;
        var credential = error.credential;
        if (error.response && error.response.data) {
          this.$toast.error(error.response.data);
        } else {
          this.$toast.error('There was an issue with your login. Please contact Teamio support');
        }
      } finally {
        logger.step('finished');
        await new Promise(resolve => setTimeout(resolve, 500));
        this.localLoading = false; // Reset local loading state
        this.setLoading(false); // Reset store loading state
      }
    },

    async handleClickMicrosoftSignIn() {
      const logger = createLoginLogger('microsoft');
      logger.step('button-clicked');
      try {
        this.localLoading = true; // Set local loading state to true
        this.setLoading(true); // Also update the store loading state

        // Initialize and login with Microsoft
        logger.step('msal-popup-begin');
        const msalResponse = await microsoftAuthService.loginWithPopup(logger.id);

        // Prefer the access token returned by loginPopup, fall back to explicit interactive acquire
        let accessToken = msalResponse && msalResponse.accessToken ? msalResponse.accessToken : null;
        if (!accessToken) {
          logger.step('access-token-missing-acquire-fallback');
          accessToken = await microsoftAuthService.getAccessToken(false, logger.id);
        }

        // Extract the actual sign-in email from MSAL response
        const signInEmail = msalResponse.account?.username || msalResponse.account?.name;

        // Send both access token and sign-in email to backend
        logger.step('backend-call-begin', { signInEmail });
        const res = await this.microsoftLogin({ accessToken, signInEmail, loginAttemptId: logger.id });
        logger.step('backend-call-result', {
          status: res && res.status,
          userCount: Array.isArray(res && res.data) ? res.data.length : (res && res.data ? 1 : 0),
        });

        if(res && res.status === 200) {
          if (Array.isArray(res.data) && res.data.length > 1) {
            logger.step('route-select-site', { siteCount: res.data.length });
            localStorage.setItem('userSites', JSON.stringify(res.data));
            this.$router.push({path: '/select-site'});
            return;
          } else {
            // Pass router as part of the context to the store action
            logger.step('handle-select-site');
            await this.$store.dispatch('customer/handleSelectSite', res.data);
          }
        }
        logger.step('login-complete');
      } catch(error) {
        var errorMessage = error.message;
        if (error.errorCode === 'user_cancelled') {
          // User cancelled login - benign, don't show an error toast
          logger.step('user-cancelled');
          console.log('User cancelled Microsoft login');
        } else {
          logger.error('failed', error);
          if (error.response && error.response.data) {
            this.$toast.error(error.response.data);
          } else {
            this.$toast.error('There was an issue with your Microsoft login. Please contact Teamio support');
          }
        }
      } finally {
        logger.step('finished');
        await new Promise(resolve => setTimeout(resolve, 500));
        this.localLoading = false; // Reset local loading state
        this.setLoading(false); // Reset store loading state
      }
    },
    
    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },
    

  },
  computed: {
    ...mapGetters('customer', ['isLoggedIn']),
    ...mapState({
        loading: state => state.alert.loading,
        loaded: state => state.alert.loaded,
        errored: state => state.alert.errored,
        alertMessage: state => state.alert.message,
        dismissSuccessCountDown : state => state.alert.dismissSuccessCountDown,
        customerID: state => state.customer.customerID,
        siteID: state => state.customer.siteID,
        userID: state => state.customer.userID,
        sites: state => state.customer.sites,
        employees: state => state.customer.employees,
        settings: state => state.customer.settings,
        statuses: state => state.customer.statuses,
        lists: state => state.customer.lists,
        automations: state => state.customer.automations
    }),

    isLoading() {
      return this.localLoading;
    }
  },
  watch: {
  },
};
</script>

<style src="./Login.scss" lang="scss" scoped />
